

















































































































































































































































































































import _ from "lodash";
import moment from "moment";
import { MaterielApi } from "../api/MaterielApi";
import { UserApi } from "../api/UserApi";
import { ANOMALIE_TYPES } from "../models/Materiel";
import { Contact } from "../models/Contact";
import { Employe } from "../models/Employe";
import { DateUtils } from "../utils/DateUtils";
import ContactSelect from "../core/Forms/ContactSelect.vue";
import DateInput from "../core/Forms/DateInput.vue";
import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import PhotoUploader from "../core/Forms/PhotoUploader.vue";
import SignaturePad from "../core/Forms/SignaturePad.vue";
import TextInput from "../core/Forms/TextInput.vue";
import TextareaInput from "../core/Forms/TextareaInput.vue";
import TimeInput from "../core/Forms/TimeInput.vue";
import EquipementPicker from "./EquipementPicker.vue";

export default {
    name: "MouvementPanel",
    components: {
        ContactSelect,
        DateInput,
        EmployeSelect,
        EquipementPicker,
        PhotoUploader,
        SignaturePad,
        TextInput,
        TextareaInput,
        TimeInput,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        refreshKey: Number,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            UserApi: new UserApi(),
            anomalieTypes: ANOMALIE_TYPES,
            selected: [],
            showPicker: false,
            dateStr: moment().format("DD/MM/YYYY"),
            heureStr: moment().format("HH[h]mm"),
            client: null,
            destinationLibre: "",
            employe: null,
            notes: "",
            responsableNom: "",
            hasAnomaly: false,
            anomTypes: [],
            anomDesc: "",
            anomPhotos: [],
            saving: false,
            // Incrémenté pour reconstruire les champs dont la valeur n'est lue
            // qu'à la création (DateInput, ContactSelect).
            formKey: 0,
        };
    },
    created() {
        let self = this;
        self.UserApi.getCurrentUser().then(function (user) {
            self.responsableNom = user ? user.name : "";
        });
    },
    mounted() {
        let self = this;
        self.resizePads();
        self.$nextTick(function () {
            self.resizePads();
        });
    },
    computed: {
        selectedIds(): Array<number> {
            return _.map(this.selected, "id");
        },
        pickerLabel(): string {
            if (this.selected.length === 0) {
                return "📦 Sélectionner un équipement…";
            }
            if (this.selected.length === 1) {
                return "✓ " + this.selected[0].libelle;
            }
            return "✓ " + this.selected.length + " équipements sélectionnés";
        },
        destinationLabel(): string {
            return this.type === "out"
                ? "Destination / Chantier"
                : "Origine / Chantier";
        },
        /**
         * Équipements sélectionnés dont la sortie en cours portait déjà une
         * anomalie (bandeau bleu du mode retour).
         */
        preAnomalies(): Array<any> {
            if (this.type !== "in") {
                return [];
            }
            let res = [];
            _.forEach(this.selected, function (equipement) {
                let dernier = equipement.dernier_mouvement;
                if (dernier && dernier.type === "out" && dernier.anomalie) {
                    res.push({ equipement: equipement, mouvement: dernier });
                }
            });
            return res;
        },
    },
    methods: {
        changeType(type: string): void {
            if (type !== this.type) {
                this.$emit("update:type", type);
            }
        },
        resizePads(): void {
            if (this.$refs.sigEmp) {
                this.$refs.sigEmp.resizeCanvas();
            }
            if (this.$refs.sigMgr) {
                this.$refs.sigMgr.resizeCanvas();
            }
        },
        truncate(text: string, max: number): string {
            if (!text) {
                return "";
            }
            return text.length > max ? text.substring(0, max) + "…" : text;
        },
        unselect(equipement): void {
            this.selected = _.filter(this.selected, function (eq) {
                return eq.id !== equipement.id;
            });
        },
        onPickerConfirm(equipements): void {
            this.selected = equipements;
            this.showPicker = false;
            this.prefillFromDernieresSorties();
        },
        /**
         * En mode retour, reprend l'employé et la destination de la sortie en
         * cours quand ils sont identiques pour tous les équipements retenus et
         * que le champ correspondant est encore vide (comportement du
         * prototype).
         */
        prefillFromDernieresSorties(): void {
            if (this.type !== "in" || !this.selected.length) {
                return;
            }

            let sorties = _.filter(
                _.map(this.selected, "dernier_mouvement"),
                function (mouvement) {
                    return !!mouvement && mouvement.type === "out";
                }
            );

            if (!sorties.length) {
                return;
            }

            let premiere = sorties[0];
            let memeEmploye = _.every(sorties, function (mouvement) {
                return mouvement.employe_id === premiere.employe_id;
            });
            let memeDestination = _.every(sorties, function (mouvement) {
                return (
                    mouvement.client_id === premiere.client_id &&
                    (mouvement.destination_libre || "") ===
                        (premiere.destination_libre || "")
                );
            });

            let rebuild = false;

            if (memeEmploye && premiere.employe_id && !this.employe) {
                this.employe = new Employe(
                    premiere.employe || {
                        id: premiere.employe_id,
                        nom: premiere.employe_nom,
                        prenom: "",
                    }
                );
            }

            if (memeDestination && !this.client && !this.destinationLibre) {
                if (premiere.client_id && premiere.client) {
                    this.client = new Contact(premiere.client);
                    rebuild = true;
                } else if (premiere.destination_libre) {
                    this.destinationLibre = premiere.destination_libre;
                }
            }

            if (rebuild) {
                this.formKey++;
            }
        },
        isAnomTypeChecked(code: string): boolean {
            return _.includes(this.anomTypes, code);
        },
        toggleAnomType(code: string): void {
            if (this.isAnomTypeChecked(code)) {
                this.anomTypes = _.without(this.anomTypes, code);
            } else {
                this.anomTypes = this.anomTypes.concat([code]);
            }
        },
        addAnomPhoto(photo): void {
            this.anomPhotos.push(photo);
        },
        removeAnomPhoto(index: number): void {
            this.anomPhotos.splice(index, 1);
        },
        onPhotoError(message: string): void {
            this.$emit("toast", { message: message, kind: "error" });
        },
        toastError(message: string): void {
            this.$emit("toast", { message: message, kind: "error" });
        },
        save(): void {
            let self = this;

            if (!self.selected.length) {
                self.toastError("Sélectionnez au moins un équipement");
                return;
            }

            if (!self.employe || !self.employe.id) {
                self.toastError("Employé requis");
                return;
            }

            let dateSql = DateUtils.dateStrToSql(self.dateStr);
            let heureSql = /^\d{2}h\d{2}$/.test(self.heureStr || "")
                ? moment(self.heureStr, "HH[h]mm").format("HH:mm")
                : "";

            if (!dateSql || !heureSql) {
                self.toastError("Date et heure requises");
                return;
            }

            let signatureEmploye = self.$refs.sigEmp
                ? self.$refs.sigEmp.getData()
                : null;
            let signatureResponsable = self.$refs.sigMgr
                ? self.$refs.sigMgr.getData()
                : null;

            if (!signatureEmploye || !signatureResponsable) {
                self.toastError("Signatures requises");
                return;
            }

            let anomalie =
                self.hasAnomaly &&
                (self.anomTypes.length > 0 ||
                    !!self.anomDesc ||
                    self.anomPhotos.length > 0);

            let payload = {
                equipement_ids: self.selectedIds,
                type: self.type,
                date_mouvement: dateSql,
                heure_mouvement: heureSql,
                client_id: self.client ? self.client.id : null,
                destination_libre: self.client ? "" : self.destinationLibre,
                employe_id: self.employe.id,
                notes: self.notes,
                anomalie: anomalie,
                anomalie_types: anomalie ? self.anomTypes : [],
                anomalie_description: anomalie ? self.anomDesc : "",
                signature_employe: signatureEmploye,
                signature_responsable: signatureResponsable,
            };

            let photos = anomalie ? self.anomPhotos.slice() : [];
            let nbMouvements = self.selectedIds.length;

            self.saving = true;

            self.MaterielApi.createMouvements(payload)
                .then(function (mouvements) {
                    // L'anomalie est dupliquée sur chaque ligne du lot : ses
                    // photos sont rattachées à chacun des mouvements créés.
                    let chain = Promise.resolve();
                    _.forEach(mouvements, function (mouvement) {
                        _.forEach(photos, function (photo) {
                            chain = chain.then(function () {
                                return self.MaterielApi.addMouvementPhoto(
                                    mouvement.id,
                                    photo.id
                                );
                            });
                        });
                    });
                    return chain;
                })
                .then(function () {
                    self.saving = false;
                    self.$emit("toast", {
                        message:
                            (nbMouvements > 1
                                ? nbMouvements + " mouvements enregistrés"
                                : "Mouvement enregistré") +
                            (anomalie ? " (anomalie signalée)" : ""),
                        kind: "success",
                    });
                    self.resetForm();
                    self.$emit("saved");
                })
                .catch(function (error) {
                    self.saving = false;
                    self.toastError(self.errorMessage(error));
                });
        },
        /**
         * Message d'erreur de l'API : message métier (422 « unprocessable »)
         * ou première erreur de validation.
         */
        errorMessage(error): string {
            let data = (error && error.response && error.response.data) || {};

            if (data.errors) {
                let first: any = _.first(_.values(data.errors));
                if (_.isArray(first) && first.length) {
                    return first[0];
                }
                if (_.isString(first)) {
                    return first;
                }
            }

            return (
                data.message ||
                (data.error && data.error.message) ||
                "Impossible d'enregistrer le mouvement."
            );
        },
        resetForm(): void {
            let self = this;
            self.selected = [];
            self.dateStr = moment().format("DD/MM/YYYY");
            self.heureStr = moment().format("HH[h]mm");
            self.client = null;
            self.destinationLibre = "";
            self.employe = null;
            self.notes = "";
            self.hasAnomaly = false;
            self.anomTypes = [];
            self.anomDesc = "";
            self.anomPhotos = [];
            self.formKey++;

            if (self.$refs.sigEmp) {
                self.$refs.sigEmp.clear();
            }
            if (self.$refs.sigMgr) {
                self.$refs.sigMgr.clear();
            }

            self.$nextTick(function () {
                self.resizePads();
            });
        },
    },
    watch: {
        type: function () {
            // Les équipements éligibles diffèrent d'un sens à l'autre.
            this.selected = [];
        },
    },
};
